export default __webpack_public_path__ + "static/media/Blooded Arm-straps of the Mound.21b5d7e6.jpg";